/* The above class is a JavaScript GHL helper class that retrieves user data by sending a request to a server and
decrypting the response using a key. */
export class GHL {
  appId;

  constructor() {}

  async getUserData() {
    try {
      // Request encrypted user data from parent window (HighLevel)
      const key = await new Promise((resolve, reject) => {
        // Set a timeout to prevent hanging indefinitely
        const timeout = setTimeout(() => {
          window.removeEventListener("message", messageHandler);
          reject(new Error("Timeout: No response from parent window"));
        }, 10000); // 10 second timeout

        const messageHandler = ({ data }) => {
        if (data.message === "REQUEST_USER_DATA_RESPONSE") {
            clearTimeout(timeout);
            window.removeEventListener("message", messageHandler);
            resolve(data.payload);
        }
        };

        window.addEventListener("message", messageHandler);
        window.parent.postMessage({ message: "REQUEST_USER_DATA" }, "*");
      });

      // Send encrypted data to backend for decryption
    const res = await fetch('/decrypt-sso', {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ key })
      });

      if (!res.ok) {
        let errorMessage = "Failed to decrypt user data";
        try {
          const errorData = await res.json();
          errorMessage = errorData.error || errorMessage;
        } catch {
          // If response is not JSON, try to get text
          const errorText = await res.text();
          errorMessage = errorText || errorMessage;
        }
        throw new Error(errorMessage);
      }

      const data = await res.json();
      
      // Validate that we received valid user data
      if (!data || !data.userId || !data.companyId) {
        throw new Error("Invalid user data received from server");
      }

      return data;
    } catch (error) {
      console.error("Error getting user data:", error);
      throw error;
    }
  }
}
